import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.doRender)?_c('div',{staticClass:"view view_Profil"},[(_vm.tabs.length > 0)?_c('viewTabsTop',{attrs:{"tabs":_vm.tabs}}):_vm._e(),_c(VContainer,[(_vm.currentTab.code === '')?_c('MeineDaten'):_vm._e(),(_vm.currentTab.code === '010')?_c('Kontoeinstellungen'):_vm._e()],1),(_vm.tabs.length > 0)?_c('viewTabsBottom',{attrs:{"tabs":_vm.tabs}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }